// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1ktdB","selects":"Documents_selects__iq1zt"};